// extracted by mini-css-extract-plugin
module.exports = {"noPoints":"styles_noPoints__1qxmn","cardBody":"styles_cardBody__1_SMJ","button":"styles_button__2VDYt"};